import { useParamsSearch } from '@anytag/shared-hooks';
import { MarketplaceAutoManagedCampaignSearchSchemaType } from '../schemaTypes';

export const useMarketplaceAutoManagedCampaignFilter = () =>
  useParamsSearch<MarketplaceAutoManagedCampaignSearchSchemaType>();
